import Vue from "vue";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
VXETable.config({
  zIndex: 5000
});
Vue.use(VXETable);
